// extracted by mini-css-extract-plugin
export var avatarImg = "customer-section-module--avatarImg--ab5c4";
export var disabledIcon = "customer-section-module--disabledIcon--55e8f";
export var dot = "customer-section-module--dot--17fa9";
export var flipHorizontal = "customer-section-module--flipHorizontal--e5f1e";
export var gradienetBackground = "customer-section-module--gradienetBackground--7cb37";
export var lightText = "customer-section-module--lightText--665c4";